//import {Row} from 'antd';
import {
  Row,
  // Col,
  Form,
  Input,
  // Space,
  // Button,
  // DatePicker,
  Select,
  // InputNumber,
  // message,
  // Modal,
} from "antd";

import classes from "../Pages.module.css";
import DataField from "./DataField";
import axios from "axios";
import DynamicTableModal from "./Mrir";
// import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useState, useContext } from "react";
import DataContext from "../../../Context/dataContext";
// const { Option } = Select;

const Consumption = (props) => {
  console.log(props, "trtrtrtrt");
  const employeeData = useContext(DataContext);
  // const [sizef, setSizef] = useState([]);
  // const [gradef, setGradef] = useState([]);
  // const [uomf, setUomf] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  // const [edi, setEdi] = useState(false);
  const [mkir, setMkir] = useState(null);
  // const pcsRef = useRef(null);

  const [form] = Form.useForm();

  const showModal = (index) => {
    const f_date = props.data5.f_date; // Retrieve f_date
    const t_date = props.data5.t_date; // Retrieve t_date

    console.log(f_date, t_date); // Log the dates for debugging
    console.log(index); // Log the index

    axios
      .get(`${employeeData.URL}/api/v1/transport/get-all-invoice`, {
        params: { f_date, t_date }, // Pass query parameters
        withCredentials: true, // Allow credentials if needed
      })
      .then((response) => {
        console.log(response); // Handle API response
        setMkir(response.data.data);
        setIsModalVisible(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error); // Handle errors
      });

    setSelectedIndex(index);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleRemoveRow = (index) => () => {
    // Remove the row by filtering out the element at the given index
    props.setData((prevData) => {
      const updatedData = prevData.prodConsumDet.filter(
        (_, idx) => idx !== index
      ); // Remove the item at 'index'

      // Recalculate the total tr_amt after removing the row
      const totalTrAmt = updatedData.reduce(
        (sum, item) => sum + (item.tr_amt || 0),
        0
      );

      console.log(totalTrAmt, "Total of tr_amt after row removed");

      return {
        ...prevData,
        prodConsumDet: updatedData,
        prodHdr: [
          {
            ...prevData.prodHdr[0],
            freight_net_amount: totalTrAmt, // Update freight_net_amount with the new sum of tr_amt
          },
        ],
      };
    });
  };

  const mapRowToProdConsumDet = (row) => ({
    import_no: row.rec_code, // Example mapping
    mrir_inv_date: row.mrir_inv_date,
    truck_no1: row.truck_no,
    customer_name: row.party_distributor_desc,
    party_wt: row.net_wt,
    pcs:row.pcs,
    // trans_wt: row.transporter_name, // Map appropriately
    basic_tr_rate: row.basic_rate,
  });

  const updateProdConsumDet = (selectedRow, selectedIndex) => {
    // Map the selected row to the desired format
    console.log(selectedRow, "selected row");
    const mappedData = mapRowToProdConsumDet(selectedRow);
    console.log("Mapped Data:", mappedData);

    // Update the state and form values with the selected index
    props.setData((prevData) => {
      const updatedProdConsumDet = prevData.prodConsumDet.map(
        (item, index) => (index === selectedIndex ? mappedData : item) // Replace data at the selected index
      );

      const updatedData = {
        ...prevData,
        prodConsumDet: updatedProdConsumDet, // Update prodConsumDet
      };

      // Update form values
      form.setFieldsValue({ prodConsumDet: updatedProdConsumDet });

      return updatedData;
    });

    // Close the modal after the update
    setTimeout(() => setIsModalVisible(false), 100);
  };

  // const handlechangee1 = async (changedValues, allValues, i) => {
  //   setEdi(true);

  //   setSizef(sizef);
  //   const values = form.getFieldsValue(["prodConsumDet"]);

  //   values.prodConsumDet[i].Mode = false;
  //   values.prodConsumDet[i].size_code = null;
  //   values.prodConsumDet[i].uom_code = null;
  //   values.prodConsumDet[i].quality_code = null;

  //   form.setFieldsValue(values);

  //   // pcsRef.current.value = null;
  //   // sizeRef.current.value = null;

  //   props.setData((data) => {
  //     // console.log(data);
  //     // console.log(data);

  //     axios
  //       .get(
  //         employeeData.URL +
  //           "/api/v1/opening/additional-data-of-hsn/ " +
  //           data.prodConsumDet[i].item_code,
  //         {
  //           withCredentials: true,
  //         }
  //       )

  //       .then((response) => {
  //         // console.log(response);
  //         const uomOptions = response.data.data.uom.rows.map((option) => ({
  //           label: option[response.data.data.uom.fields[1].name],
  //           value: option[response.data.data.uom.fields[0].name],
  //         }));

  //         // Automatically set uom_code if there is only one option
  //         if (uomOptions.length === 1) {
  //           values.prodConsumDet[i].uom_code = uomOptions[0].value;
  //           form.setFieldsValue(values);
  //         }

  //         setUomf((prevUomf) => {
  //           const newUomf = [...prevUomf];
  //           newUomf[i] = uomOptions.map((option) => (
  //             <Option
  //               style={{ textTransform: "capitalize", color: "#1777C4" }}
  //               key={option.value}
  //               value={option.value}
  //             >
  //               {option.label}
  //             </Option>
  //           ));
  //           return newUomf;
  //         });

  //         setSizef((prevSizef) => {
  //           // console.log(prevSizef, " In the 83 line");
  //           const newSizef = [...prevSizef];
  //           newSizef[i] = response.data.data.size.rows.map((option) => (
  //             <Option
  //               style={{ textTransform: "capitalize", color: "#1777C4" }}
  //               key={option[response.data.data.size.fields[0].name]}
  //               value={option[response.data.data.size.fields[0].name]}
  //             >
  //               {option[response.data.data.size.fields[1].name]}
  //             </Option>
  //           ));
  //           // console.log(newSizef);
  //           return newSizef;
  //         });

  //         setGradef((prevGradef) => {
  //           const newGradef = [...prevGradef];
  //           newGradef[i] = response.data.data.grade.rows.map((option) => (
  //             <Option
  //               style={{ textTransform: "capitalize", color: "#1777C4" }}
  //               key={option[response.data.data.grade.fields[0].name]}
  //               value={option[response.data.data.grade.fields[0].name]}
  //             >
  //               {option[response.data.data.grade.fields[1].name]}
  //             </Option>
  //           ));
  //           return newGradef;
  //         });
  //       });

  //     return {
  //       ...data,
  //     };
  //   });
  // };

  const handleChange = (index) => (event) => {
    const value = event.target.value ? parseFloat(event.target.value) : 0; // Convert to float or set to 0 if empty

    // Update the prodConsumDet in your data
    props.setData((prevData) => {
      console.log(prevData); // Log previous data for debugging

      // Create a copy of the previous data
      const updatedData = [...prevData.prodConsumDet]; // Assuming prevData has a prodConsumDet key

      // Update trans_wt and calculate tr_amt
      updatedData[index].trans_wt = value; // Update trans_wt at index
      updatedData[index].tr_amt = value * updatedData[index].trans_rate; // Calculate tr_amt based on trans_wt and trans_rate
      // Calculate diff_amt
      updatedData[index].diff_amt =
        updatedData[index].tr_amt - updatedData[index].final_amt;
      // Return the updated state, preserving other properties in prevData
      const totalTrAmt = updatedData.reduce(
        (sum, item) => sum + (item.tr_amt || 0),
        0
      );
      console.log(totalTrAmt, "ttttttttttttttttttt");
      return {
        ...prevData,
        prodConsumDet: updatedData,
        prodHdr: [
          {
            ...prevData.prodHdr[0],
            freight_net_amount: totalTrAmt, // Update freight_net_amount with the sum of tr_amt
          },
          ...prevData.prodHdr.slice(1), // Preserve the rest of prodHdr array if it has more elements
        ],
      }; // Spread prevData and update prodConsumDet
    });
  };

  const handleChangeTransRate = (index) => (event) => {
    const value = event.target.value ? parseFloat(event.target.value) : 0; // Convert to float or set to 0 if empty

    // Update the prodConsumDet in your data
    props.setData((prevData) => {
      console.log(prevData); // Log previous data for debugging

      const updatedData = [...prevData.prodConsumDet]; // Assuming prevData has a prodConsumDet key

      updatedData[index].trans_rate = value; // Update trans_rate at index
      updatedData[index].tr_amt = updatedData[index].trans_wt * value; // Recalculate tr_amt based on new trans_rate and existing trans_wt
      // Calculate diff_amt
      updatedData[index].diff_amt =
        updatedData[index].tr_amt - updatedData[index].final_amt;
      const totalTrAmt = updatedData.reduce(
        (sum, item) => sum + (item.tr_amt || 0),
        0
      );
      console.log(totalTrAmt, "ttttttttttttttttttt");
      return {
        ...prevData,
        prodConsumDet: updatedData,
        prodHdr: [
          {
            ...prevData.prodHdr[0],
            freight_net_amount: totalTrAmt, // Update freight_net_amount with the sum of tr_amt
          },
          ...prevData.prodHdr.slice(1), // Preserve the rest of prodHdr array if it has more elements
        ],
      }; // Spread prevData and update prodConsumDet
    });
  };

  const handleChangeUpdateRate = (index) => (event) => {
    const value = event.target.value ? parseFloat(event.target.value) : 0; // Convert to float or set to 0 if empty

    // Update the prodConsumDet in your data
    props.setData((prevData) => {
      console.log(prevData); // Log previous data for debugging

      const updatedData = [...prevData.prodConsumDet]; // Assuming prevData has a prodConsumDet key

      updatedData[index].update_rate = value; // Update trans_rate at index
      updatedData[index].final_amt = updatedData[index].party_wt * value; // Recalculate tr_amt based on new trans_rate and existing trans_wt
      // Calculate diff_amt
      updatedData[index].diff_amt =
        updatedData[index].tr_amt - updatedData[index].final_amt;
      return { ...prevData, prodConsumDet: updatedData }; // Spread prevData and update prodConsumDet
    });
  };

  const handleValueChanges = (changedValues, allValues) => {
    props.setData((data) => {
      return {
        ...data,
        prodConsumDet: allValues.prodConsumDet,
        // invoiceSize1: changedValues.invoiceSize,
      };
    });
  };

  return props.editMode ? (
    <Form
      layout="vertical"
      name="filter_form"
      onValuesChange={handleValueChanges}
      autoComplete="off"
      form={form}
    >
      <div className="component-container">
        <Form.List name="prodConsumDet" initialValue={props.data}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, i) => (
                  <table
                    id="table_order"
                    className="table table-bordered"
                    style={{
                      tableLayout: "fixed",
                      width: "2450px",
                      marginBottom: "-2rem",
                    }}
                  >
                    {i === 0 && (
                      <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        <tr
                          style={{
                            height: "0.4rem",
                            backgroundColor: "rgb(217 217 217 / 35%)",
                          }}
                        >
                          <th style={{}}>
                            {" "}
                            Ref No/Challan{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>

                          {/* <th style={{}}>
                            City{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}
                          <th style={{}}>
                            Invoice Date{" "}
                            {/* <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span> */}
                          </th>
                          {/* <th style={{}}>
                            Cost Center{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}
                          {/* <th style={{}}>Avail. Qty</th> */}
                          {/* <th style={{}}>
                            Gr No{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}

                          <th style={{}}>
                            Truck No{" "}
                            {/* <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span> */}
                          </th>
                          {/* <th style={{}}>
                            Dealer{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}
                          <th style={{}}>Customer</th>
                          {/* <th style={{}}>Freight Type</th> */}
                          <th style={{}}>Net Weight</th>
                          <th style={{}}>Pc's</th>
                          <th style={{}}>Trans Wt</th>
                          <th style={{}}>M.Rate</th>
                          <th style={{}}>Tr.rate</th>
                          <th style={{}}>Our Rate</th>
                          <th style={{}}>Tr.Fixed</th>
                          <th style={{}}>Our Fixed</th>

                          <th style={{}}>Tr.Amount</th>
                          <th style={{}}>Final Amount</th>
                          <th style={{}}>Sel Opt</th>
                          <th style={{}}>Dff Amt</th>

                          <th style={{ width: "8%", textAlign: "left" }}>#</th>
                        </tr>
                      </thead>
                    )}

                    <tbody
                    // style={{
                    //   width: "12%",
                    //   height: "10px",
                    //   // border: "2px solid black",
                    // }}
                    >
                      <tr
                        style={
                          {
                            // border: "2px solid red",
                          }
                        }
                      >
                        <td
                          style={{
                            // width: "12%",
                            // height: "10px",
                            border: "1px solid white",
                          }}
                        >
                          <Form.Item
                            // style={{ border: "2px solid red" }}
                            {...restField}
                            name={[name, "import_no"]}
                            fieldKey={[fieldKey, "import_no"]}
                            //  label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}></div>}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",
                                width: "80%",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              placeholder=""
                              onClick={() => showModal(i)}
                            />
                          </Form.Item>
                        </td>

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "to_place"]}
                            fieldKey={[fieldKey, "to_place"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",
                                // width: "80%",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td> */}

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "mrir_inv_date"]}
                            fieldKey={[fieldKey, "mrir_inv_date"]}
                            // label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}></div>}
                            // rules={[{ required: true, message: 'Missing Name' }]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",
                                // width: "80%",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                              disabled={true}
                            />
                          </Form.Item>
                        </td>

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "gr_no"]}
                            fieldKey={[fieldKey, "gr_no"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td> */}

                        <td
                          style={{
                            textAlign: "right",
                            border: "1px solid white",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "truck_no1"]}
                            fieldKey={[fieldKey, "truck_no1"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                              disabled={true}
                            />
                          </Form.Item>
                        </td>

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "dealer_name"]}
                            fieldKey={[fieldKey, "dealer_name"]}

                            // label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}></div>}
                            // rules={[{ required: true, message: 'Missing Name' }]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td> */}

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "customer_name"]}
                            fieldKey={[fieldKey, "customer_name"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                              disabled={true}
                            />
                          </Form.Item>
                        </td>

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "freight_type"]}
                            fieldKey={[fieldKey, "freight_type"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td> */}

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "party_wt"]}
                            fieldKey={[fieldKey, "party_wt"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              disabled={true}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>
                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "pcs"]}
                            fieldKey={[fieldKey, "party_wt"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              disabled={true}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "trans_wt"]}
                            fieldKey={[fieldKey, "trans_wt"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              type="number"
                              onChange={handleChange(i)}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "basic_tr_rate"]}
                            fieldKey={[fieldKey, "basic_tr_rate"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",
                                backgroundColor: "white",
                                color: "#000000",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "trans_rate"]}
                            fieldKey={[fieldKey, "trans_rate"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              type="number"
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                              onChange={handleChangeTransRate(i)}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "update_rate"]}
                            fieldKey={[fieldKey, "update_rate"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              type="number"
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                              onChange={handleChangeUpdateRate(i)}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "trans_fixed"]}
                            fieldKey={[fieldKey, "trans_fixed"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "fixed_rate"]}
                            fieldKey={[fieldKey, "fixed_rate"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "tr_amt"]}
                            fieldKey={[fieldKey, "tr_amt"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              disabled={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "final_amt"]}
                            fieldKey={[fieldKey, "final_amt"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              disabled={true}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "sel_opt"]}
                            fieldKey={[fieldKey, "sel_opt"]}
                          >
                            <Select
                              style={{
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            >
                              <Select.Option value="MST">MST</Select.Option>
                              <Select.Option value="TRP">TRP</Select.Option>
                              <Select.Option value="OUR">OUR</Select.Option>
                              <Select.Option value="TFX">TFX</Select.Option>
                              <Select.Option value="OFX">OFX</Select.Option>
                            </Select>
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "diff_amt"]}
                            fieldKey={[fieldKey, "diff_amt"]}
                          >
                            <Input
                              style={{
                                textAlign: "right !important",

                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // value={item.diff_amt}
                              readOnly
                              bordered={true}
                              className={classes["ant-input-number-input1"]}
                              placeholder=""
                            />
                          </Form.Item>
                        </td>
                        {/* onChange={handleChangee} */}
                        <td
                          style={{
                            border: "1px solid white",
                            // border: "2px solid red",
                            width: "8%",
                            textAlign: "left",
                          }}
                        >
                          <MinusCircleOutlined
                            className={classes["Remove"]}
                            onClick={() => {
                              console.log("Before removing row");
                              handleRemoveRow(i)(); // Call your custom remove handler first
                              console.log(
                                "After handleRemoveRow, before removing from form"
                              );
                              remove(name); // Remove the row from the form list
                            }}
                          />

                          <PlusCircleOutlined
                            className={classes["Add"]}
                            onClick={() => {
                              add({
                                import_no: null,
                                mrir_inv_date: null,
                                truck_no1: null,
                                party_wt: null,
                                trans_wt: null,
                                basic_tr_rate: null,
                                trans_rate: null,
                                update_rate: null,
                                trans_fixed: null,
                                fixed_rate: null,
                                sel_opt: null,
                                ref_mrir: null,
                                ref_mrir_type: null,
                              });
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}

                {/* <Form.Item>
                  <Button
                    type="dashed"
                    id="add_item"
                    onClick={() => {
                      add();
                    }}
                  ></Button>
                </Form.Item> */}
              </>
            );
          }}
        </Form.List>
      </div>
      {mkir && mkir.mrir && mkir.mrir.rows && mkir.mrir.rows.length > 0 && (
        <DynamicTableModal
          mkir={mkir.mrir} // Pass MRIR data
          isModalVisible={isModalVisible}
          handleOk={handleOk}
          handleCancel={handleCancel}
          selectedIndex={selectedIndex}
          updateProdConsumDet={updateProdConsumDet}
        />
      )}
    </Form>
  ) : (
    <>
      {props.data.map((data, index) => {
        return (
          <div key={index}>
            <p></p>
            <Row
              className={props.editMode ? classes["RowDEX"] : classes["RowD"]}
            >
              <DataField
                editMode={false}
                lg={12}
                md={24}
                options={props.ad.ITEM_CODE}
                type="Select"
                name="Item"
                value={data.item_code}
              />
            </Row>
            <p></p>
          </div>
        );
      })}
    </>
  );
};

export default Consumption;
